/**
* Sticky Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Sticky Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'sticky-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function scrollCards() {
        $( '.sticky-cards' ).each( function( key, val ) {
          let topOffset = $( '.navbar' ).height();

          if ( $( '#wpadminbar' ).length ) {
            topOffset += $( '#wpadminbar' ).height();
          }

          const horizontal = $( this ).find( '.sticky-cards__inner' )[0];

          gsap.to( horizontal, {
            x: () => horizontal.scrollWidth * ( window.isRtl ? 1 : -1 ),
            xPercent: window.isRtl ? -100 : 100,
            scrollTrigger: {
              trigger: this,
              start: 'top ' + topOffset,
              end: '+=2000px',
              pin: this,
              scrub: true,
              invalidateOnRefresh: true,
            },
          } );
        } );
      }

      const mm = gsap.matchMedia();

      mm.add( '(min-width: 1023px)', () => {
        scrollCards();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'sticky-cards', COMPONENT );
} )( app );
